// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3FA3C","row":"ProcedureTreatmentSummary_row__3cEoA"};